export const environment = {
  production: true,
  fallbackLocale: 'en-CA',
  tenant: 'activities_CAN',
  widget: false,
  serviceWorker: {
    enable: true,
  },
  e2e: {
    // enable e2e mode with data-test markup
    enable: false,
  },
  applications: {
    datadog: {
      applicationId: 'f2062e7c-738c-4e68-80c7-431aede71afb',
      clientToken: 'pub479f0afae0f5f45fa57ee25866064036',
    },
    cdn: {
      host: 'https://activities-assets.decathlon.net/legacy',
      root: 'https://activities-assets.decathlon.net',
    },
    phrase: {
      locales: {
        'fr-CA': '4fa6755b42958f1c5477b5d4a6dc6ddf',
        'en-CA': '58c3475333a62f3946cec708f2c156ec',
      },
    },
    front: {
      url: 'https://activities.decathlon.ca',
      domain: 'activities.decathlon.ca',
    },
    woosmap: {
      apiKey: 'woos-6e588fc5-a1e3-3d39-9ee1-28b713fdd5df',
      gmapApiKey: 'AIzaSyDG3jq0cm9JoLe9E8PCAZaawAHrfQ7U_ss',
      locale: 'country:ca',
    },
    amplitude: {
      apiKey: 'c06224e8147966f6ffae12a7f2d7d198',
    },
    gtm: {
      id: 'GTM-MTM3WV9',
    },
    sentry: {
      dsn: 'https://0fc1729944bc4fa1a21e1cab26bd34ad@sentry.io/1396593',
      environment: 'production-CAN',
      enabled: true,
    },
    talkjs: {
      appId: 'MiNI5v1A',
    },
    activities: {
      url: 'https://api-eu.decathlon.net/activities/v2',
      api_key: '3350e701-e67c-4732-b08d-31e76de910bf',
    },
    strapi: {
      url: 'https://activities.decathlon.ca/strapi-api',
      locale: '',
    },
    stripe: {
      apiKey: 'pk_live_HHUBQrl2UIew34g2aC6haMxJ00HnLYVoVA',
      authorizeUri: 'https://connect.stripe.com/express/oauth/authorize',
      apiUrl: 'https://connect.stripe.com',
    },
    pfs: {
      url: 'https://europe-west1-services-platform-pwlg.cloudfunctions.net/api',
    },
    advice: {
      url: 'https://api-global.decathlon.net/cms',
      apiKey: 'c1bd69cf-9822-49be-819a-a42dd47cb043',
    },
    reviews: {
      url: 'https://reviews.decathlon.com',
    },
    onepay: {
      host: 'https://onepay-widget.decathlon.net',
    },
  },
  auth: {
    fed: {
      issuer: 'https://idpdecathlon.oxylane.com',
      redirectUri: 'https://activities.decathlon.ca/auth/redirection',
      clientId: 'Cc73544e2464f2bbb5585c8508f0d4ceba0afa720',
      userinfoEndpoint: 'https://idpdecathlon.oxylane.com/idp/userinfo.openid',
      discoveryDocument:
        'https://idpdecathlon.oxylane.com/.well-known/openid-configuration',
    },
    connect: {
      issuer: 'https://api-eu.decathlon.net/connect',
      redirectUri: 'https://activities.decathlon.ca/auth/redirection',
      clientId: '5bc4f121-4848-441b-917d-cef0a06c847c',
      discoveryDocument:
        'https://api-global.decathlon.net/connect/.well-known/openid-configuration',
      logoutRedirectionUrl: 'https://activities.decathlon.ca/auth/logout',
    },
  },
};
